import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import './index.css'

const Layout = ({ children }) => (
  <div>
    <Helmet>
      <html lang="el"/>
      <meta name="apple-mobile-web-app-title" content="Ό&nu;&epsilon;&iota;&rho;&omicron;"/>
      <meta name="application-name" content="Ό&nu;&epsilon;&iota;&rho;&omicron;"/>
      <meta name="msapplication-TileColor" content="#da532c"/>
      <meta name="theme-color" content="antiquewhite"/>

      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
      <link rel="manifest" href="/site.webmanifest"/>
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5"/>

      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans|Roboto+Slab"
        rel="stylesheet"
      />
    </Helmet>
    <div>
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout





// WEBPACK FOOTER //
// ./src/layouts/index.js